<template>
  <div class="m-video-wrap">
    <div class="video-info">
      <TopNoticePc></TopNoticePc>
      <div
        class="video-main"
        :class="{ wide: isWide, switch: docState }"
        id="video-main"
      >
        <File></File>
        <div class="video-box">
          <div
            id="video"
            class="video-content"
            v-show="isLiveStatus || isPlayBackStatus"
          >
            <!--            保利威弹幕 块-->
            <div v-if="playerType == 'polyv'" class="mudu-video-danmaku"></div>
          </div>
          <div class="def-img" v-show="!isLiveStatus && !isPlayBackStatus">
            <div
              class="video-tips"
              :style="{
                background:
                  'url(' +
                  template.meeting.videoBg.src.value +
                  ') center no-repeat',
                'background-size': 'contain'
              }"
            ></div>
          </div>
        </div>
        <div class="switch-box"></div>
      </div>
      <div class="video-opea">
        <div class="opea-left">
          <div
            v-if="!ReplayliveState"
            :class="{
              'opea-status-no-live': isLiveStatus,
              'opea-status': !isLiveStatus
            }"
          >
            {{ vadioStatus }}
          </div>
          <div v-if="ReplayliveState" class="opea-status">
            回放
          </div>
          <div class="opea-items" v-if="isShowOnlineNum">
            人气：{{ onlineUserNumber }}
          </div>
          <!--<div class="opea-items">声量:50</div>-->
        </div>
        <div class="opea-right">
          <Liner></Liner>
          <div
            v-show="webinarInfo.replaySwitch !== 1"
            class="opea-items"
            @click="toggleBarrage"
          >
            <span
              :class="
                isBarrage && !docState ? 'barrage-on-new' : 'barrage-off-new'
              "
            ></span>
            <span class="opea-text">弹幕</span>
          </div>
          <div
            v-show="webinarInfo.replaySwitch !== 1"
            class="opea-items"
            @click="changeScreenStatus"
          >
            <span
              class="icon icontemp "
              :class="isWide ? 'shrink' : 'widescreen'"
            ></span>
            <span class="opea-text">{{ isWide ? "窄屏" : "宽屏" }}</span>
          </div>
          <!--<div class="opea-items">-->
          <!--<span class="icon icontemp cutover"></span>-->
          <!--<span class="opea-text">小窗</span>-->
          <!--</div>-->
          <!--<div class="opea-items">-->
          <!--<span class="icon icontemp shared"></span>-->
          <!--<span class="opea-text">收藏</span>-->
          <!--</div>-->

          <Like :device="'pc'"></Like>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, ck } from "fire-wind-water";
import { mixinsTemplate } from "../../common/mixinsTemplate";
import TopNoticePc from "./TopNoticePc";
import Like from "./Like";
import File from "./File";
import Liner from "./Line";
import DanmuJs from "@/common/danmu";
import { replaceColon } from "@/common/emoji";
import $ from "jquery";
import URL from "@/assets/conf/setting.json";
import { socketModule } from "../../common/socket";
import comonService from "../../services/comonService";

export default {
  name: "Video",
  components: { TopNoticePc, File, Like, Liner },
  mixins: [mixinsTemplate],
  data() {
    return {
      onlineUserNumber: "",
      isShowOnlineNum: false,
      isLiveStatus: false,
      vadioStatus: "暂无直播",
      isBarrageInit: false,
      isBarrage: false,
      isVisible: true,
      webinarInfo: {},
      isWide: false,
      userInfo: {},
      danmu: null,
      isPlayBackStatus: false, //视频模块回放状态
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 &&
        window.location.href.indexOf("isSetting=1") > -1
          ? true
          : false, //静态链接回放状态
      playerType: "" //播放器 类型
    };
  },
  computed: {
    docState() {
      return this.$store.state.docState;
    }
  },
  watch: {
    docState() {
      if (this.isBarrage) {
        if (this.docState) {
          this.danmu.stop();
        } else {
          this.danmu.start();
        }
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      window.$sk.webinar.module({
        //播放器状态
        skPlayerStatus(res) {
          let data = res[0];
          if (data.content.data == "直播回放") {
            _this.isPlayBackStatus = true;
            _this.vadioStatus = "回放";
          } else if (data.content.data == "暂无回放") {
            _this.vadioStatus = "暂无回放";
          } else {
            $subscriber.emit("onVideoStatus", data); //发布播放器是回放状态
          }
        },
        //监听： 视频播放
        skPlayer(res) {
          let videoStatus = res[0];
          //开始 链接 soket
          if (socketModule.isOn == null) {
            socketModule.init(URL.webinarbInteractUrl + "center", null);
            socketModule.connect(_this.userInfo, _this.webinarInfo, function() {
              _this.logPlayStart();
            });
          } else {
            _this.logPlayStart();
          }
          $subscriber.emit("playerButtonStatus", videoStatus);
        },
        //监听： 视频暂停
        skStoped(res) {
          let videoStatus = res[0];
          _this.logPlayStop();
          if (socketModule.isOn !== null) {
            socketModule.disconnect_connect();
            $subscriber.emit("playerButtonStatus", videoStatus);
          }
        },
        //监听： 视频结束
        skEnded(res) {
          let videoStatus = res[0];
          _this.logPlayStop();
          if (socketModule.isOn !== null) {
            socketModule.disconnect_connect();
            $subscriber.emit("playerButtonStatus", videoStatus);
          }
        },
        //监听： 视频切换
        skSdkVideoChangeUrl(res) {
          $subscriber.emit("simulateClickEvent", res[0]);
        },
        // 监听 播放器初始化
        skPlayerInit(res) {
          _this.initDanmu();
        }
      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
      });
      $subscriber.subscribe("onUserOnlineNum", data => {
        this.isShowOnlineNum = data.show ? true : false;
        this.onlineUserNumber = data.num;
      });

      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
        let ck_isBarrage = ck.cookie("isBarrage_" + this.webinarInfo.webinarId);
        if (ck_isBarrage) {
          this.isBarrage = ck_isBarrage;
        }
        this.vadioStatus = data.replaySwitch == 1 ? "暂无回放" : "暂无直播";
        this.playerType = data.webCastProvider;
      });
      $subscriber.subscribe("onQAGet", qa => {
        let isSelf = this.userInfo.applicantId == qa.from_user.uid;
        let message = replaceColon(qa.content);
        if (qa.from_user.role == 0) {
          this.addDanmu({ id: qa._id, message, isSelf });
        }
      });
      $subscriber.subscribe("onVideoStatus", data => {
        this.vadioStatus =
          data.content.data == "直播" ? "正在直播" : "暂无直播";
        this.isLiveStatus = data.content.data == "直播" ? true : false;
      });
      $subscriber.subscribe("toggleNotifyStatus", isShowNotify => {
        $(".mudu-video-danmaku").css({
          top: isShowNotify ? $(".pc-notice").height() : 0
        });
      });
    },
    logPlayStart() {
      let _this = this;
      comonService.logPlayStart({
        id: _this.userInfo.id,
        socketId: socketModule.socket.id,
        tenantId: _this.webinarInfo.tenantId,
        webinarId: _this.webinarInfo.webinarId,
        globalUserId: ck.cookie("globalUserId")
      });
    },
    logPlayStop() {
      let _this = this;
      comonService.logPlayStop({
        id: _this.userInfo.id,
        socketId: socketModule.socket.id,
        tenantId: _this.webinarInfo.tenantId,
        webinarId: _this.webinarInfo.webinarId,
        globalUserId: ck.cookie("globalUserId")
      });
    },
    changeScreenStatus() {
      this.isWide = !this.isWide;
      $subscriber.emit("changeScreenStatus");
    },

    toggleBarrage() {
      if (this.docState) {
        $subscriber.emit("showPopup", {
          message: "抱歉，PPT为主屏幕时，无法开启弹幕功能。",
          delay: 2000
        });
        return;
      }
      if (!this.isBarrageInit) {
        $subscriber.emit("showPopup", {
          message: "不要着急，请稍后操作。",
          delay: 2000
        });
        return;
      }
      this.isBarrage = !this.isBarrage;
      ck.cookie("isBarrage_" + this.webinarInfo.webinarId, this.isBarrage, {
        expires: 1,
        domain: window.$sk.config.domain,
        path: "/"
      });
      if (this.isBarrage) {
        this.danmu.start();
      } else {
        this.danmu.stop();
        this.isBarrageInit = false;
        setTimeout(() => {
          this.isBarrageInit = true;
        }, 250);
      }
    },

    initDanmu() {
      this.danmu = new DanmuJs({
        container: document.querySelector(".mudu-video-danmaku"),
        containerStyle: {
          height: "120px"
        },
        channelSize: 40
      });
      this.isBarrageInit = true;

      window.danmu = this.danmu;
      document.addEventListener("visibilitychange", () => {
        this.isVisible = document.visibilityState === "visible";
      });
    },

    /**
     * 发送弹幕
     * @param id 唯一标识
     * @param message 弹幕内容
     * @param isSelf 是否为自己发送（会特殊标记）
     */
    addDanmu({ id, message, isSelf }) {
      if (this.docState) return; // PPT为主屏幕时，不播放弹幕（弹幕的div主体一直跟随视频框）
      if (!this.isBarrageInit) return; // 弹幕不可使用
      if (!this.isBarrage) return; // 未开启弹幕
      if (!this.isVisible) return; // 窗口不可见时，不添加新弹幕（css3动画机制问题）
      let messageBox = $(
        `<div class="${
          isSelf ? "danmu-mess self" : "danmu-mess"
        }">${message}</div>`
      );
      this.danmu.sendComment({
        id: id + "",
        duration: 20000,
        noDiscard: true,
        noDiscardFirst: true,
        isFirst: isSelf,
        el: messageBox.get(0)
      });
    }
  }
};
</script>

<style lang="scss"></style>
